import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/Organization.svg'
import _imports_1 from '@/assets/Contract.svg'
import _imports_2 from '@/assets/User.svg'
import _imports_3 from '@/assets/Aggregate.svg'
import _imports_4 from '@/assets/Reconcile.svg'
import _imports_5 from '@/assets/Company.svg'
import _imports_6 from '@/assets/Info.svg'
import _imports_7 from '@/assets/SignOut.svg'


const _hoisted_1 = {
  class: "container",
  id: "header"
}
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-8 text-start h2" }
const _hoisted_4 = {
  key: 0,
  id: "btnMenu",
  class: "btn rounded-circle",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#menu",
  "aria-controls": "menu"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "app-name" }, "≡", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "app-name" }, " 顧客管理システム ", -1)
const _hoisted_8 = { class: "col-4 login-info mt-1 text-end h8" }
const _hoisted_9 = { id: "OrganizationName" }
const _hoisted_10 = { id: "UserName" }
const _hoisted_11 = {
  class: "offcanvas offcanvas-start",
  tabindex: "-1",
  id: "menu",
  "aria-labelledby": "menuLabel"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "offcanvas-header" }, [
  /*#__PURE__*/_createElementVNode("h3", {
    class: "offcanvas-title",
    id: "menuLabel"
  }, "Menu"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close text-reset",
    "data-bs-dismiss": "offcanvas",
    "aria-label": "Close"
  })
], -1)
const _hoisted_13 = { class: "offcanvas-body" }
const _hoisted_14 = {
  class: "nav flex-column",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "団体管理", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "契約管理", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "ユーザー管理", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "集計", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "入金消込", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "自社管理", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "アップデート管理", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "サインアウト", -1)
const _hoisted_31 = { class: "offcanvas-footer mb-1" }
const _hoisted_32 = { class: "m-0" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "m-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "© 2022-2024 Sinmedict Co.,Ltd.")
], -1)

import { ref, withDefaults, computed, onMounted} from "vue";
  import { useStore } from "@/store"

// #endregion

// #region フレームワークインスタンスの取得

  // ストアインスタンスの取得
  
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  setup(__props) {


/********************************************************************************
 * ヘッダーメニューモジュール
 *
 * @since 2022/08/25
 * @author 松本裕介
 *
 *********************************************************************************/

// #region モジュールのインポート

  // フレームワークのインポート
  const store = useStore();

// #endregion

//#region インターフェース定義

//#endregion

//#region プロパティの宣言と初期化

//#endregion

//#region リアクティブ設定

  // 団体名
  const OrganizationName = computed((): string => {return store.state.auth.OrganizationName === undefined ? "" : store.state.auth.OrganizationName;});

  // ユーザー名
  const UserName = computed((): string => {return store.state.auth.UserName === undefined ? "" : store.state.auth.UserName;});

  // バージョン情報
  const reactVersion = ref(process.env.VUE_APP_VERSION);

//#endregion


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(store).state.auth.Token)
            ? (_openBlock(), _createElementBlock("button", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(OrganizationName)), 1),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(UserName)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          _createElementVNode("nav", _hoisted_14, [
            _createVNode(_component_router_link, { to: "/organization" }, {
              default: _withCtx(() => [
                _hoisted_15,
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/contract" }, {
              default: _withCtx(() => [
                _hoisted_17,
                _hoisted_18
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/user" }, {
              default: _withCtx(() => [
                _hoisted_19,
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/aggregate" }, {
              default: _withCtx(() => [
                _hoisted_21,
                _hoisted_22
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/reconcile" }, {
              default: _withCtx(() => [
                _hoisted_23,
                _hoisted_24
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/company" }, {
              default: _withCtx(() => [
                _hoisted_25,
                _hoisted_26
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/update" }, {
              default: _withCtx(() => [
                _hoisted_27,
                _hoisted_28
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/signin" }, {
              default: _withCtx(() => [
                _hoisted_29,
                _hoisted_30
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("p", _hoisted_32, [
          _createElementVNode("span", null, _toDisplayString(`vbtmscom ver ${reactVersion.value}`), 1)
        ]),
        _hoisted_33
      ])
    ])
  ], 64))
}
}

})